import { render, staticRenderFns } from "./DashboardBreadcrumb.vue?vue&type=template&id=7048aee2&"
import script from "./DashboardBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./DashboardBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports